import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import { AllRoutes } from "../api/routes";
import competition_banner from "../assets/events.avif"

const Events = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        AllRoutes.fetchEvents().then(res => {
            if (res.success) setEvents(res.data);
            setLoading(false);
        });
    }, []);

    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="h-[300px] flex items-center justify-center"
                // style={{ background: "linear-gradient(135deg, #1e3a5f 0%, #0f6cbd 100%)" }}
                style={{
                    backgroundImage: `url(${competition_banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
                >
                <div className="text-center px-4">
                    <h1 className="text-5xl font-bold text-white mb-4">Events</h1>
                    <p className="text-blue-100 text-lg">Challenges hosted by GAASH Lab</p>
                </div>
            </div>

            <div className="container mx-auto px-4 py-12">
                {loading ? (
                    <p className="text-center text-gray-500">Loading...</p>
                ) : events.length === 0 ? (
                    <p className="text-center text-gray-500">No Events yet.</p>
                ) : (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {events.map(comp => (
                            <CompetitionCard key={comp.slug} competition={comp} />
                        ))}
                    </div>
                )}
            </div>
            <ScrollToTop />
        </div>
    );
};

const statusColor = {
    upcoming: "bg-yellow-100 text-yellow-800",
    ongoing: "bg-green-100 text-green-800",
    completed: "bg-red-100 text-red-600",
};

const CompetitionCard = ({ competition }) => (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
        {competition.banner_image ? (
            <img src={competition.banner_image} alt={competition.title} className="w-full h-48 object-cover" />
        ) : (
            <div className="w-full h-48 bg-gradient-to-r from-blue-600 to-blue-400 flex items-center justify-center">
                <span className="text-white text-2xl font-bold px-4 text-center">{competition.title}</span>
            </div>
        )}
        <div className="p-6 flex flex-col">
            <div className="flex justify-between items-center mb-2">
                <span className={`text-xs px-3 py-1 rounded-full font-medium ${statusColor[competition.status]}`}>
                    {competition.status.charAt(0).toUpperCase() + competition.status.slice(1)}
                </span>
                <span className="text-xs text-gray-400">{competition.start_date}</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">{competition.title}</h3>
            <p className="text-gray-600 text-sm mb-4 flex-grow">{competition.short_description}</p>
            <Link
                to={`/events/${competition.slug}`}
                className="group w-full text-center py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
                >
                View Details

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 ml-2 transition-transform duration-300 group-hover:-rotate-45"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                    fillRule="evenodd"
                    d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                    />
                </svg>
            </Link>
        </div>
    </div>
);

export default Events;